module.exports = __webpack_public_path__ + "img/7.aa58b8a7.jpg";